export enum EPaymentProvider {
  M3 = 'M3',
  RT = 'RT',
  PW = 'PW',
  SPAYZ = 'SPAYZ',
}

export const paymentProviderByString = (value: string): EPaymentProvider =>
  EPaymentProvider[value.toUpperCase() as keyof typeof EPaymentProvider]
